(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initChoices = (root) => {
    const choices = Array.from(root.querySelectorAll('[data-yn-choice]'));
    const resultPanels = Array.from(root.querySelectorAll('[data-yn-result-panel]'));
    const resultStage = root.querySelector('[data-yn-result-stage]');

    if (!choices.length || !resultStage) return;

    const selectChoice = (choice, shouldFocus = false) => {
      const key = choice.dataset.ynChoice;

      choices.forEach((button) => {
        const selected = button === choice;
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.tabIndex = selected ? 0 : -1;
      });

      resultPanels.forEach((panel) => {
        panel.hidden = panel.dataset.ynResultPanel !== key;
      });

      root.dataset.ynSelectedRitual = key;

      if (shouldFocus) choice.focus({ preventScroll: true });

      if (window.matchMedia('(max-width: 767px)').matches) {
        window.requestAnimationFrame(() => {
          const stageTop = resultStage.getBoundingClientRect().top;
          if (stageTop > window.innerHeight * 0.84) {
            resultStage.scrollIntoView({
              behavior: reducedMotion.matches ? 'auto' : 'smooth',
              block: 'start'
            });
          }
        });
      }
    };

    choices.forEach((choice, index) => {
      choice.addEventListener('click', () => selectChoice(choice));
      choice.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % choices.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + choices.length) % choices.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = choices.length - 1;
        selectChoice(choices[nextIndex], true);
      });
    });
  };

  const initEmpowerment = (root) => {
    const carousel = root.querySelector('[data-yn-empowerment]');
    const track = carousel?.querySelector('[data-yn-empowerment-track]');
    const slides = Array.from(carousel?.querySelectorAll('[data-yn-empowerment-slide]') || []);
    const previous = carousel?.querySelector('[data-yn-empowerment-prev]');
    const next = carousel?.querySelector('[data-yn-empowerment-next]');
    const dots = Array.from(carousel?.querySelectorAll('[data-yn-empowerment-dot]') || []);

    if (!track || slides.length < 2) return;

    let activeIndex = 0;
    let scrollFrame = 0;

    const updateControls = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === activeIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
    };

    const goTo = (index) => {
      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: slides[targetIndex].offsetLeft - track.offsetLeft,
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
      updateControls(targetIndex);
    };

    previous?.addEventListener('click', () => goTo(activeIndex - 1));
    next?.addEventListener('click', () => goTo(activeIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

    track.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = 0;
        const trackLeft = track.getBoundingClientRect().left;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });
        updateControls(nearestIndex);
      });
    }, { passive: true });

    updateControls(0);
  };

  const initVideos = (root) => {
    root.querySelectorAll('[data-yn-video-play]').forEach((button) => {
      const media = button.closest('.yn-p4-routine-card__media');
      const video = media?.querySelector('video');
      if (!video) return;

      const sync = () => {
        button.querySelector('span').textContent = video.paused ? '▶' : '❚❚';
        button.setAttribute('aria-label', video.paused ? 'Play routine clip' : 'Pause routine clip');
      };

      button.addEventListener('click', async () => {
        if (video.paused) {
          root.querySelectorAll('.yn-p4-routine-card video').forEach((other) => {
            if (other !== video) other.pause();
          });
          try {
            await video.play();
          } catch (error) {
            // Native controls remain available if the browser blocks playback.
          }
        } else {
          video.pause();
        }
        sync();
      });

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      sync();
    });
  };

  const initMobileMenu = (root) => {
    const menu = root.querySelector('.yn-p4-mobile-menu');
    if (!menu) return;
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => menu.removeAttribute('open'));
    });
  };

  const init = (root) => {
    if (root.dataset.ynP4Initialized === 'true') return;
    root.dataset.ynP4Initialized = 'true';
    initChoices(root);
    initEmpowerment(root);
    initVideos(root);
    initMobileMenu(root);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-yn-home-p4]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
